import { put, select, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { updateConversationContent, addConversationsMessage, clearConversations, selectConversationCategory, selectConversations, setConversationCategory, setProgress, setFopFilter, selectFopFilter } from "./conversationsSlice";
import { isToday, isYesterday } from "date-fns";
import { format } from "path";
import { selectUserDetails } from "../user/userSlice";

const getTypeForRequest = (conversations) => {
    if (conversations && conversations?.length !== 0) {
        let requestParams = conversations[conversations.length - 1]?.message?.requestParams;
        if (requestParams !== undefined) {
            return {
                ...requestParams
            };
        }
    }
    return {};
}

const convertDate = (dateString) => {
    const date = new Date(dateString);
  
    // if (isToday(date)) {
    //   return `Today ${format(date, 'HH:mm')}`;
    // } else if (isYesterday(date)) {
    //   return `Yesterday ${format(date, 'HH:mm')}`;
    // } else {
    //   return format(date, 'dd/MM/yyyy HH:mm');
    // }
  };

function* clearChat(event) {
    yield put(clearConversations(event.payload));
}
function* messageSend(event) {
    const conversations = yield select(selectConversations);    
    const conversationCategory = yield select(selectConversationCategory);    
    const fopFilter = yield select(selectFopFilter);    

    let data: any = {
        message: event.payload,
        type: "sent",
        timeStamp: new Date().getTime()
    };
    const userDetails = yield select(selectUserDetails);
    data.user = userDetails;

    yield put(addConversationsMessage(data));
    let progress:any = true;
    let categoryType: any = undefined;
    
    if(conversationCategory === "Generic") {
        categoryType = "free-chat";
    }
    try {
        let type = getTypeForRequest(conversations);
        yield put(setProgress(progress));
        let response;
        if (event.payload.file) {
            const formData = new FormData();
            formData.append('file', event.payload.file);
            if (type?.type) {
                formData.append('type', type.type);
            }
            const payload = {
                ...event.payload,
                type: categoryType,
                
                ...type,
            }
            if(conversationCategory === "Generic") {
                payload["datasetFilterValue"] = fopFilter
            }
            response = yield axios.post("/chat", payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
        } else {
            const payload = {
                ...event.payload,
                type: categoryType,
                
                ...type,
            }
            if(conversationCategory === "Generic") {
                console.log("fopFilterfopFilterfopFilter", fopFilter);
                
                payload["datasetFilterValue"] = fopFilter
            }
            response = yield axios.post("/chat", payload);
        }
        progress = false;
        yield put(setProgress(progress));
        yield put(addConversationsMessage(response.data));
    } catch (error) {
        console.error("API error:", error);
        progress = false;
        yield put(setProgress(progress));
        let data: any = [
            {
                message: {
                    component: "option-select",
                    content: {
                        options: [
                            {
                                value: "Solutioning",
                                label: "Solutioning"
                            },
                            {
                                value: "Delivery",
                                label: "Delivery"
                            }
                        ],
                        title: "Which scenario best suits your requirement?",
                        subtitle: "Select from the below options:"
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
            {
                message: {
                    component: "file-select",
                    content: {
                        title: "Please upload your RFP documents",
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
            {
                message: {
                    component: "message-reply",
                    content: {
                        title: "Please provide opportunity id to proceed:",
                        subtitle: "Please type in your response below:"
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
            {
                message: {
                    component: "parsing-document",
                    content: {
                        title: "We are parsing the documents you uploaded.",
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
            {
                message: {
                    component: "successfully-uploaded-document",
                    content: {
                        title: "Documents uploaded successfully, click on the below button to view the document(s) uploaded:",
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
            {
                message: {
                    component: "successfully-parsed-document",
                    content: {
                        title: "We have successfully parsed your document",
                        subtitle: "Based on RFP, following is the summary of required solution:",
                        parsedData: [
                            {
                                label: "Customer",
                                value: "BridgeStone"
                            },
                            {
                                label: "Requirement Summary",
                                value: "Bridgestone Corporation is looking for ESG Data Management & Reporting Solution covering Bridgestone Europe, Middle East and Africa, NV. (BSEMIA), Bridgestone Americas, Inc. (BSAM), Bridgestone Japan (BSJP) and Bridgestone China and Asia Pacific Pte.Ltd. (BSCAP) scope with International Sustainability Standards Board (ISSB) and the Global Reporting Initiative (GRI)"
                            },
                            {
                                label: "Solution use case",
                                value: "Dashboard, Report"
                            },
                            {
                                label: "ESG Reporting Regions",
                                value: "US / EMEA / APAC"
                            },
                            {
                                label: "Sustainability framework",
                                value: "IFRS, ESRS, GRI"
                            },
                            {
                                label: "Deployment Regions",
                                value: "US / EMEA"
                            },
                        ]
                    }
                },
                type: "received",
                timeStamp: new Date().getTime()
            },
        ];
        let msg: any = {
            message: {
                component: "message-reply",
                content: {
                    title: "Something went wrong:",
                    subtitle: "We encountered some error from the backend"
                }
            },
            type: "received",
            timeStamp: new Date().getTime()
        };
        // yield put(addConversationsMessage(data[0]));
        // yield put(addConversationsMessage(data[1]));
        // yield put(addConversationsMessage(data[2]));
        // yield put(addConversationsMessage(data[3]));
        // yield put(addConversationsMessage(data[4]));
        // yield put(addConversationsMessage(data[5]));
        yield put(addConversationsMessage(msg));
    }

}
function* categoryChange(event) {
    yield put(setConversationCategory(event.payload));
}
function* updateContent(event) {
    yield put(updateConversationContent(event.payload));
}
function* fopFilterChange(event) {
    yield put(setFopFilter(event.payload));
}

export function* conversationsSaga() {
    yield takeEvery("CONVERSATION_MESSAGE_SEND", messageSend);
    yield takeEvery("CONVERSATION_UPDATE_CONTENT", updateContent);
    yield takeEvery("CLEAR_CONVERSATION_CHATS", clearChat);
    yield takeEvery("CATEGOTY_CHANGE", categoryChange);
    yield takeEvery("FOP_FILTER_CHANGE", fopFilterChange);
}